import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthProvider';

export function SignIn() {
  const { signIn, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError('');
    try {
      await signIn(email.trim(), password);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Sign in failed.');
    }
  }

  return (
    <main className="signin-stage" data-stakd-theme="light">
      <section className="signin-card" aria-labelledby="signin-title">
        <div className="brand-lockup"><strong>STAKD</strong><span>PARTNER OS</span></div>
        <p className="eyebrow">SECURE OPERATING CONSOLE</p>
        <h1 id="signin-title">Sign in to your workspace</h1>
        <p className="muted">For authorized sponsors, program teams, creator partners, and STAKD staff.</p>
        <form onSubmit={submit}>
          <label>Email<input type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required /></label>
          <label>Password<input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required /></label>
          {error ? <div className="error" role="alert">{error}</div> : null}
          <button className="primary-button" disabled={loading}>{loading ? 'Signing in…' : 'Sign in'}</button>
        </form>
        <p className="security-note">Protected by Supabase Auth and row-level security. Access is limited to your assigned organizations and partner account.</p>
      </section>
    </main>
  );
}
